// Robust helper to extract plain text from values that may be JSON strings or objects
// Handles cases like: '{ "response": "..." }', '```json{...}```', nested content fields, and plain text

export function extractTextFromMaybeJson(input: unknown): string {
  if (input == null) return "";

  // If it's already a non-empty string, try to detect JSON inside
  if (typeof input === "string") {
    const trimmed = input.trim();

    // Unwrap markdown code fences ``` ... ``` optionally with json language tag
    if (trimmed.startsWith("```") && trimmed.endsWith("```")) {
      let inner = trimmed.slice(3, -3);
      if (inner.startsWith("json")) inner = inner.slice(4);
      return extractTextFromMaybeJson(inner);
    }

    // Try JSON.parse on string
    try {
      const parsed = JSON.parse(trimmed);
      return extractTextFromMaybeJson(parsed);
    } catch {
      // Not JSON, return as-is
      return trimmed;
    }
  }

  // If it's an object, try common fields in order of preference
  if (typeof input === "object") {
    const obj = input as Record<string, unknown>;
    const candidateKeys = [
      "content",
      "response",
      "text",
      "message",
      "data",
    ];

    for (const key of candidateKeys) {
      if (key in obj && obj[key] != null) {
        const value = obj[key];
        const extracted = extractTextFromMaybeJson(value);
        if (extracted) return extracted;
      }
    }

    // Fallback: stringify compactly without braces when possible
    try {
      return JSON.stringify(obj);
    } catch {
      return "";
    }
  }

  // Numbers/booleans
  if (typeof input === "number" || typeof input === "boolean") {
    return String(input);
  }

  return "";
}


